<style>
	 @import '@/assets/css/custom.css';
	 
	 .hover-bg-light:hover {
		 background-color: #f8f9fa !important;
	 }
	 
	 .cursor-pointer {
		 cursor: pointer;
	 }
</style>

<template>
    <div>
        <Breadcrumbs main="Boards" title="Firmware Failed" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<!-- <div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" data-original-title="test" @click="openModal">Add Board</button>
									</div>
								</div>
							</div> -->

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchFirmwareFailed()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchFirmwareFailed()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Vendor Name</th>
											<th>Serial Number</th>
											<th>IMEI</th>
											<th>ICCID</th>
											<th>Firmware Status</th>
											<th>Updated On</th> 
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(boards.length)">
                                        <tr v-for="(board, index) in boards" :key="board.id" align="center">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ board.vendor_name }}</td>
                                            <td>{{ board.serial_number }}</td>
                                            <td>{{ board.imei }}</td>
											<td>{{ board.iccid }}</td>
                                            <td>
												<span v-if="board.firmware_status == 1">
													<span class="badge rounded-pill bg-info">Pending</span>
												</span>
												<span v-if="board.firmware_status == 2">
													<span class="badge rounded-pill bg-success">Firmware Success</span>
												</span>
												<span v-if="board.firmware_status == 3">
													<span class="badge rounded-pill bg-danger">Firmware Failed</span>
												</span>
											</td>
                                            <td>{{ $filters.formatDate(board.updated_at) }}</td>
                                            <td>
												<router-link v-if="board.firmware_status == 3" :to="{ name: 'board_detail', params: { id: board.id } }" class="btn btn-primary btn-sm me-2 mb-2">Update</router-link>
												<!-- <div v-if="board.status == 1">
													<button class="btn btn-success btn-sm me-2 mb-2" @click="openModal(board.id)">Firmware Success</button>
													<button class="btn btn-danger btn-sm me-2 mb-2" @click="failedFirmware(board.id)">Firmware Failed</button>
												</div>
												<div v-if="board.status == 2">
													<button class="btn btn-danger btn-sm me-2 mb-2" @click="failedFirmware(board.id)">Firmware Failed</button>
												</div> -->
                                            </td>
                                        </tr>
                                      
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(boards.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchFirmwareFailed(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Firmware Update">
			<template #body>
				<form @submit.prevent="markBoardFirmwareSuccess" enctype="multipart/form-data">
					<!-- Current Batch Information -->
					<div class="row" v-if="currentBatch">
						<div class="col-md-12">
							<div class="alert alert-info">
								<strong>Current Batch:</strong> {{ currentBatch.batch_number }}<br>
								<strong>Total Boards:</strong> {{ currentBatch.total_boards }}
							</div>
							<button type="button" class="btn btn-success btn-sm mb-3" @click="createNewBatch">Start New Batch</button>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">Device Model<span class="text-danger">*</span></label>
                        	<select v-model="device_model_id" class="form-select" required>
								<option value="">Select Device Model</option>
								<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
							</select>
                        </div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">IMEI<span class="text-danger">*</span></label>
                        	<input v-model="imei" class="form-control" rows="3"/>
                        </div>
					</div>
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Select ICCID<span class="text-danger">*</span></label>
                        	<div class="position-relative">
								<input 
									v-model="iccid_search" 
									class="form-control" 
									placeholder="Search ICCID..."
									@input="searchIccid"
									@focus="showIccidSuggestions = true"
									@blur="hideIccidSuggestions"
								/>
								<div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
									<div 
										v-for="iccid in filteredIccidList" 
										:key="iccid.id"
										class="p-2 border-bottom cursor-pointer hover-bg-light"
										@click="selectIccid(iccid)"
										style="cursor: pointer;"
									>
										{{ iccid.iccid }}
									</div>
								</div>
							</div>
                        </div>
                    </div>

					<div class="row" v-if="selectedIccid">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 1<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_1" class="form-control" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 2<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_2" class="form-control" disabled/>
                        </div>
                    </div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Firmware Version<span class="text-danger">*</span></label>
							<select v-model="firmware_version" class="form-select">
								<option value="">Select</option>
								<option value="AWNVer 6.49.2+494">AWNVer 6.49.2+494</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
							<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
						</div>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Board Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Add Board",
				button_title: "Save",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                vendor: "",
				stock: "",
				imei: "",
				iccid_search: "",
				selectedIccid: null,
				showIccidSuggestions: false,
				filteredIccidList: [],
				board_id: "",
				firmware_status: "",
				
				boards: [],

				iccid_list: [],
				currentBatch: null,
				deviceModels: [],
				device_model_id: "",
				firmware_version: "",
				loading: false,
			};
		},
		created() {
			this.fetchFirmwareFailed();
			this.fetchIccidList();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchFirmwareFailed(page_url = null) {
				this.getToken();
				let url = "/staffs/firmwareFailureBoardsList?limit=" + this.listing_length  +  "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.boards = responseData.data;
						this.pagination = responseData.links;
						this.from = responseData.from;
						this.to = responseData.to;
						this.total = responseData.total;
						
					})
					.catch((err) => console.log(err));
			},
			
			openModal(id) {
				this.showModal();
				this.board_id = id;
				this.imei = "";
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.filteredIccidList = [];
				this.device_model_id = "";
				this.firmware_version = "";
				this.fetchBatch();
				this.fetchDeviceModels();
			},

			closeModal() {
				this.hideModal();
			},

			clearForm() {
				this.edit = false;
                this.vendor = "";
				this.stock = "";
				this.imei = "";
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.firmware_version = "";
				this.filteredIccidList = [];
				this.device_model_id = "";
				this.modal_title = "Add Board";
				this.button_title = "Save";
				this.errors = {};
			},

			searchIccid() {
				if (this.iccid_search.trim() === '') {
					this.filteredIccidList = [];
					return;
				}
				
				this.filteredIccidList = this.iccid_list.filter(iccid => 
					iccid.iccid.toLowerCase().includes(this.iccid_search.toLowerCase())
				);
			},

			selectIccid(iccid) {
				this.selectedIccid = iccid;
				this.iccid_search = iccid.iccid;
				this.showIccidSuggestions = false;
			},

			hideIccidSuggestions() {
				setTimeout(() => {
					this.showIccidSuggestions = false;
				}, 200);
			},

			fetchBatch() {
				this.getToken();
				this.$axios
					.get("/staffs/fetchBatch", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						if (res.data.status && res.data.data) {
							this.currentBatch = res.data.data;
						} else {
							this.currentBatch = null;
						}
					})
					.catch((err) => {
						console.log(err);
						this.currentBatch = null;
					});
			},

			createNewBatch() {
				this.getToken();
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "staffs/createBatch";
				this.loading = true;

				this.$axios
					.post(url, {}, config)
					.then((response) => {
						if (response.data.status && response.data.data) {
							this.currentBatch = {
								batch_number: response.data.data.batch_number,
								total_boards: 0
							};
							this.$swal("", "New batch created: " + response.data.data.batch_number, "success");
						}
						this.loading = false;
					})
					.catch((error) => {
						this.loading = false;
						if (error.response && error.response.data && error.response.data.message) {
							this.$swal("", error.response.data.message, "error");
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			fetchDeviceModels() {
				this.getToken();
				this.$axios
					.get("/staffs/getDeviceModel", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						if (res.data.status && res.data.data) {
							this.deviceModels = res.data.data;
						} else {
							this.deviceModels = [];
						}
					})
					.catch((err) => {
						console.log(err);
						this.deviceModels = [];
					});
			},

			markBoardFirmwareSuccess()
			{
				this.getToken();
				this.errors = {};

				if (!this.device_model_id) {
					this.$swal("", "Please select a device model", "error");
					return;
				}
				if (!this.selectedIccid || !this.selectedIccid.iccid) {
					this.$swal("", "Please select an ICCID", "error");
					return;
				}
				if (!this.firmware_version) {
					this.$swal("", "Please select a firmware version", "error");
					return;
				}

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "staffs/boardFirmwareSuccess";  
				this.loading = true;
				let formData = new FormData();
				formData.append("board_id", this.board_id);
				formData.append("device_model", this.device_model_id);
				formData.append("imei", this.imei);
				formData.append("iccid", this.selectedIccid.iccid);
				formData.append("firmware_version", this.firmware_version);

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.clearForm();
					this.fetchFirmwareFailed();
				})
				.catch((error) => {
					console.log(error);
					console.log(error.response);
					if (error.response) {
						if (error.response.data.message) {
							this.errors = error.response.data.message;
							this.$swal("", error.response.data.message, "error");
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				});
			},

			failedFirmware(id) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to mark firmware of this board as failed?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.boards.find(board => board.id === id).status = 3;
					}
				});
			},

			fetchIccidList() {
				this.getToken();
				this.$axios
					.get("/staffs/getAvailableSimList", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.iccid_list = responseData.sims;
					})
					.catch((err) => console.log(err));
			},


		},
	};
</script>